import { render, staticRenderFns } from "./PreviewInteractiveTemplateForm.vue?vue&type=template&id=047ad8e2&scoped=true"
import script from "./PreviewInteractiveTemplateForm.vue?vue&type=script&lang=js"
export * from "./PreviewInteractiveTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./PreviewInteractiveTemplateForm.vue?vue&type=style&index=0&id=047ad8e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ad8e2",
  null
  
)

export default component.exports